import {name, mixins, props, data, defaultFormFields, validationsRules, EventBus} from './config'
export default {
  name,
  props,
  mixins,
  data() {
    return {
      ...data,
      success: false,
      fields: {
        token: '',
        email: this.email || '',
        password: '',
        password_confirmation: '',
      }
    }
  },
  created() {
    this.setupForm(validationsRules, defaultFormFields)
    if (!this.token) {
      this.formErrorMessage = this.$$t('form.fields.token.validations.required.message', 'Unable to find reset token')
    } else {
      this.fields.token = this.token
    }
  },
  methods: {
    getComponentExtraClasses() {
      return [{
        processed: this.success,
        disabled: !this.token
      }]
    },
    async initReset() {
      this.resetFieldsValidation()
      this.$v.$touch()
      this.formSubmitting = true
      if (!this.isAnyInvalid) {
        const fields = _.clone(this.fields)
        if (!fields.token) {
          fields.token = this.token
        }
        EventBus.$emit('password-reset.init', fields)
        try {
          const [data] = await this.promise('user.password.reset', fields)
          this.emit('password-reset.success', data)
          this.success = true
        } catch (e) {
          this.showFormError(e, {'scrollTo': '.password-reset-inputs-box'})
          this.emit('password-reset.error', e)
        } finally {
          this.emit('password-reset.end', fields)
        }
      } else {
        this.scrollToFirstErrorElement()
      }
    },
  }
}
